module.exports = __webpack_public_path__ + "static/media/km_logo.7cf48f88.png";